<template lang="pug">
section.distribution
  .head
    h2 {{ title }}
    p {{ subtitle }}
  .content.bg_blue
    img(:src="isImgPC ? imgPC : imgMobile")
</template>

<script>
export default {
  name: "Distribution",
  props: {
    title: String,
    subtitle: String,
    imgPC: String,
    imgMobile: String,
  },
  data() {
    return {
      width: 0,
    };
  },
  computed: {
    isImgPC() {
      if (this.$store.state.screenWidth > 991) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/product/intro/business_intro_head";

.distribution {
  width: 100%;
}

img {
  @include size(100%, auto);
}
</style>
